document.addEventListener("vsk:product:changed", function(e){
  updateQuickView(e)
  var productID = e.detail.productID;
  var variantDetails = JSON.parse(sessionStorage.getItem(getSessionStorageKey(productID)));
  var cardTarget = e.target;
  var cardSlider = $(cardTarget).find(".media--slider");
  var prodURL = variantDetails.onlineStoreUrl ? variantDetails.onlineStoreUrl : `/products/${variantDetails.handle}`;
  var prodImages = variantDetails.images.nodes.map(x => "<a href='" + prodURL + "' class='sa-handle' aria-hidden='true' tabindex='-1'><img src='" + x.url.split('.jpg')[0] + "_354x442_crop_center.progressive.jpg'></a>").slice(1).join("");
  var cardMain = $(cardTarget).find(".no-slider");
  var mainImage = variantDetails.images.nodes[0].url.split('.jpg')[0] + "_354x442_crop_center.progressive.jpg";
  
  setTimeout(function(){
      $(cardSlider).html(prodImages);
      $(cardMain).find(".sa-handle img").attr({"src": mainImage, "srcset": mainImage, "data-srcset": mainImage});
      // console.log(variantDetails);
  },100); 
});

function pdSlider() {

  $("body").on("mouseover", "#product-grid .grid__item .media.no-slider", function(){
    let slider = $(this).siblings(".media--slider");
    if (!slider.hasClass('slick-initialized')) {
      slider.css({ "opacity": 0, "visibility": "visible" });
      slider.slick({
        dots: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
      });
      slider.animate({ "opacity": 1 }, 400);
    }
  })

  $("body").on("mouseleave", "#product-grid .grid__item .media.media--slider", function(){
    let slider = $(this);
    if (slider.hasClass('slick-initialized')) {
      slider.animate({ "opacity": 0 }, 400, function() {
        slider.slick('unslick');
        slider.css({ "visibility": "hidden" });
      });
    }
  });
}

pdSlider();
const quickViewProductHandleMapData = new Map();
async function updateQuickView (e) {
  const productWrapper = e.target.closest("product-wrapper");

  // Check if there is a card wrapper before proceeding to re-render the quick view.
  if (productWrapper) {
    const productUrlSelected = e.target.querySelector(".swatch-group-selector.swatch-selected").getAttribute("swatch-url");
    
    let productDataRes = quickViewProductHandleMapData.get(productUrlSelected) 
    if(!productDataRes){
      const productDataReq = await fetch(`${productUrlSelected}.js`);
      productDataRes = await productDataReq.json();
      quickViewProductHandleMapData.set(productUrlSelected, productDataRes)
    }

    const productID = productDataRes.id;
    const productVariant = productDataRes.variants;

    let firstAvailableVariant = null;
    for (let i = 0; i < productVariant.length; i++) {
      const variant = productVariant[i];
      if(variant.available) {
        firstAvailableVariant = variant;
        break;
      }
    }
    let isOutOfStock = false;
    if(firstAvailableVariant == null) {
      isOutOfStock = true;
      firstAvailableVariant = productVariant[0];
    }
    // Set context to warpper
    productWrapper.setAttribute("c-context", `{"productId": ${productID}, "variantSelected": ${JSON.stringify(firstAvailableVariant)}, "quantity": 1, "formId": "product-form-${productID}" }`)
    productWrapper.setContext("formId", `product-form-${productID}`)
    productWrapper.setContext("productId", productID);
    productWrapper.setContext("variantSelected", firstAvailableVariant);
    // Update form content 
    const form = productWrapper.querySelector("form[action='/cart/add']");
    form.setAttribute("id", `product-form-${productID}`)
    form.querySelector("input[name='id']").value = firstAvailableVariant.id;
    form.querySelector("input[name='product-id']").value = productID;

    // Update image content
    updateProductImage(productDataRes)

    // Update product title
    productWrapper.querySelector(".product-title span:first-child").innerHTML = productDataRes.title;
    
    // Update variant swatch selector
    productWrapper.querySelectorAll("product-price variant-swatch-king div[sa-options-position='default'] li")
      .forEach(ele => {
        ele.addEventListener("click", (e) => {
          const optionTarget = ele.closest("div[option-name='Color']").getAttribute("option-target");
          const optionIndex = Number(optionTarget.replace("option", "")) - 1
          const newOption = [...firstAvailableVariant.options];
          newOption[optionIndex] = ele.getAttribute("orig-value");

          const newSelectedVariant = productVariant.find(variant => JSON.stringify(variant.options) == JSON.stringify(newOption))

          if(newSelectedVariant){
            setTimeout(() => {
              updateProductPrice(newSelectedVariant);
            }, 200)
          }

        })
      })

    // Update product variant selector
    const productVariantEle = productWrapper.querySelector("product-variant-swatches");
    const currentProdVariantContext = productVariantEle.getAttribute("c-data");
    const formatMoney = JSON.parse(currentProdVariantContext).moneyFormat;
    productVariantEle.setAttribute("c-data", 
      JSON.stringify({
        "variants": JSON.stringify(firstAvailableVariant), 
        "optionsWithValues": JSON.stringify(productDataRes.options),
        "variantInventoryQuantity": JSON.stringify(productVariant.map(variant => variant.available ? 1 : 0)),
        "moneyFormat": formatMoney
      })
    );
    const formId = productVariantEle.querySelector("input").getAttribute("form")
    productVariantEle.innerHTML = getVariantSelector(productDataRes, formId, firstAvailableVariant, isOutOfStock);

    productVariantEle.querySelectorAll("input[type='radio']").forEach(ele => {
      ele.addEventListener("click", (e) => {
        e.target.closest(".variant-swatches-form").querySelectorAll("label").forEach(label => {
          if(label.getAttribute("for") == e.target.id){
            label.setAttribute("checked", "true")
          }else {
            label.setAttribute("checked", "false")
          }
        });
        const selectedOptions = [];
        // Loop through each option radio button group to get the selected values
        productVariantEle.querySelectorAll('.variant-swatches-form').forEach(function (fieldset) {
          const selectedRadio = fieldset.querySelector('label[checked="true"]');

          selectedOptions.push(selectedRadio ? selectedRadio.getAttribute("option-value") : null);
        });

        // Find the correct variant that matches the selected options
        const selectedVariant = productVariant.find((variant) =>  
          JSON.stringify(selectedOptions) == JSON.stringify(variant.options)
        );

        // Update the variant ID input field with the selected variant's ID
        if (selectedVariant) {
          productWrapper.setContext("variantSelected", selectedVariant);
          // Update product price 
          updateProductPrice(selectedVariant)
          if(selectedVariant.featured_media){
            $(`form[id='product-form-${productDataRes.id}']`).find(".image--slider").slick("slickGoTo", selectedVariant.featured_media.position - 1);
          }
        }
      })
    })

    // Update product price 
    setTimeout(() => {
      updateProductPrice(firstAvailableVariant);
      updatePC9(firstAvailableVariant)
    }, 200)

    // Update quantity selector
    productWrapper.querySelector(".quantity__input").setAttribute("form", `product-form-${productID}`)

    // Update view detail product 
    productWrapper.querySelector(".view-product-details").setAttribute("href", `${productUrlSelected}`);
  }

  function updateProductImage(productDataRes) {
      const media = productDataRes.media || [];
      productWrapper.querySelector(".product-image").innerHTML = `
          ${media.length > 1 ?
              `<span class="chevronleft24x24 prev" style="">
                  <a class="jcarousel-nav jcarousel-prev prev-btn-2" title="Previous"></a
              ></span>` : ""
          }
          
          <product-image-slider>
              <div class="image--slider">
                  ${media.map((media, index) => {
                    return `
                      <div image-id="${media.id}"
                      >
                          <img src="${media.src}" alt="${media.alt}"/>
                      </div>
                  `
                  }).join("\n")
                }
              </div>
          </product-image-slider>
          ${media.length > 1 ?
              `<span class="chevronright24x24 next">
                  <a class="jcarousel-nav jcarousel-next next-btn-2" title="Next"> </a>
              </span>` : ""
          }
      `;

    $(`form[id='product-form-${productDataRes.id}']`).find(".image--slider").not(".slick-initialized").slick({
        dots: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        initialSlide: 0,
       prevArrow: $(`form[id='product-form-${productDataRes.id}']`).find(".prev"),
        nextArrow: $(`form[id='product-form-${productDataRes.id}']`).find(".next"),
      });
  }

  function updatePC9 (variant) {
    productWrapper.querySelector(".selected-variant-sku").innerHTML = `Item no. ${variant.sku ? variant.sku.splice(0,9) :""}`
  }

  function updateProductPrice(variant) {
    const productPrice = productWrapper.querySelector("product-price");
    const productPriceCData = JSON.parse(productPrice.getAttribute("c-data"))
    const moneyFormat = productPriceCData.moneyFormat.replace("{{amount}}", "{{amount_no_decimals}}") || `{{amount}} ${Shopify.currency.active}`;
    const priceElement = productWrapper.querySelector(".no-js-hidden.small-hide.price-section");
    
    const onSale = variant.compare_at_price !== null && variant.compare_at_price > variant.price;

    let percentage = onSale 
      ?  (variant.compare_at_price - variant.price) * 100 / variant.compare_at_price
      : 0
    priceElement.innerHTML = `
      <div class="price price--on-sale">
        <div class="price__container">
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline"></span>
            <span class="price-item price-item--sale price-item--last">
              ${Shopify.formatMoney(variant.price, moneyFormat)}
            </span>
            <span class="visually-hidden visually-hidden--inline"></span>
            <span>
              <span
                class="price-item price-item--regular"
                style="${onSale ? "display: inline;" : "display: none;" }"
              >
                ${Shopify.formatMoney(variant.compare_at_price, moneyFormat)}
              </span>
            </span>
          </div>
          <span
            class="discount"
            style="${onSale ? "display: inline;" : "display: none;" }"
          >
            ${Math.round(percentage * 100) / 100}% OFF
          </span>
        </div>
      </div>
    `;
  }

  function getVariantSelector (productDataRes, formId, selectedVariant, isOutOfStock) {
    const options = selectedVariant.options;
    return `
      ${productDataRes.options.map((option, idx) => {
        const selectedValue = options[idx];
        return `
          <fieldset class="variant-swatches-form  color-swatches-wrapper ">
            <legend class="option-label">${option.name}</legend>
            ${
              option.values.map((value, index) => {
                const optionName = option.name.replaceAll(" ", "-")
                const id = `${productDataRes.id}-${optionName}-${option.position}-${index}`;
                return `
                  <input type="radio" id="${id}" name="${optionName}" value="${value}" 
                    form="${formId}" 
                    checked="false"
                    data-gtm-form-interact-field-id="${index}"
                    ${isOutOfStock ? "class='disabled'" : ""}
                  >

                  <label option-name="${optionName}" option-value="${value}"
                    id="${optionName}-${value}" for="${id}" name="${optionName}" 
                    class="item-swatch ${optionName == "Color" ? "color-swatch" : ""}"
                    checked=${selectedValue == value ? "true" : "false"}
                    disabled="${isOutOfStock ? "true" : "false"}"
                  >
                    ${value}
                  </label>
                `;
              }).join("\n")
            }
            
          </fieldset>
        `
      }).join("\n")}
    `
  }
}